export const tokens = {
  radius: {card: 12, dot: 10},
  spacing: {xxs: 4, xs: 8, sm: 12, md: 16},
  sizes: {rail: 8, dot: 20},
  font: {
    h: {size: 16, weight: '600' as const},
    p: {size: 14, weight: '400' as const},
    label: {size: 12, weight: '400' as const},
  },

  progress: {
    labelMinWidth: 80,
    labelMaxWidth: 120,
    labelMinFontScale: 0.85,
    minWidth: 200,
    maxWidth: 280,
    containerPadding: 32,
    leftShiftPx: 0,
  },
};
